function photoSwipe(idx){
    var pswpElement = document.querySelectorAll('.pswp')[0];

    // build items array
    var items=[];
    $('.image_swiper').each(function(key,item){

        items.push({
            src:item.href,
            w:800,
            h:800
        });
    });

    // define options (if needed)
    var options = {
        // optionName: 'option value'
        // for example:
        index: idx // start at first slide
    };
    
    // Initializes and opens PhotoSwipe
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
}   

$('.image_swiper').click(function(e){
    e.preventDefault();
    idx = $(this).data('idx');
    photoSwipe(idx);
});